import { Checkbox as HeroUiCheckbox } from '@heroui/react';
import { type FC, memo } from 'react';
import { Controller, useFormContext } from 'FrontRoyalReactHookForm';

type VanillaCheckboxProps = {
    children: React.ReactNode;
    isSelected?: boolean;
    onValueChange?: (isSelected: boolean) => void;
    isDisabled?: boolean;
    className?: string;
    name?: string;
};

const VanillaCheckbox: FC<VanillaCheckboxProps> = memo(({ children, className, ...rest }) => (
    <HeroUiCheckbox
        {...rest}
        classNames={{
            base: 'gap-2',
            icon: 'text-white text-[14px]',
            wrapper: 'h-5 w-5 self-start justify-center me-0 mt-0.5',
            label: 'font-normal text-base leading-[21px]',
        }}
        className={className}
    >
        {children}
    </HeroUiCheckbox>
));

type CheckboxProps = {
    children: React.ReactNode;
    name: string;
    isDisabled?: boolean;
    className?: string;
};

export const Checkbox: FC<CheckboxProps> = memo(({ children, name, ...rest }) => {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <VanillaCheckbox {...rest} name={name} isSelected={!!field.value} onValueChange={field.onChange}>
                    {children}
                </VanillaCheckbox>
            )}
        />
    );
});
